import Lang from 'ln/lang/Lang';
import CourseElement from './CourseElement';
import CoursePreview from './CoursePreview';
import SlrgUserSequenceModel from '../models/SlrgUserSequenceModel';


class SlrgSequencePreview extends CourseElement {

	
	constructor( public model:SlrgUserSequenceModel, private courseView: CoursePreview ) {
		super( model, courseView );
	}
	
	public init(){
		super.init();

		this.renderDisplayTime();

		this.blankLinks();

	}
	

	protected renderDisplayTime() {
		this.node.js('display-time').html = this.model.displayTime + ' ' + Lang.translate( 'processplan.time' );
	}
	
}

export default SlrgSequencePreview;